import {traderAPI,useTraderAuth} from '../../trader/context/TraderAuthContext';
import {useTraderTheme} from '../../trader/context/TraderThemeContext';
import {useTraderLanguage} from '../../trader/context/TraderLanguageContext';
import {useWebSocket} from '../../context/WebSocketContext';
import {ConnectionStatus} from './ConnectionStatus';
export const TraderConnection=()=>{
  const {user}=useTraderAuth(),{isDark}=useTraderTheme(),{language}=useTraderLanguage(),{isConnected}=useWebSocket();
  return user?<ConnectionStatus api={traderAPI} scope="trader" identity={user.id} language={language} dark={isDark} socket={isConnected}/>:null;
};